module.exports = __webpack_public_path__ + "img/card3-bl3.069da862.svg";